/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/** @jsx jsx */
import React, { useEffect, useState } from 'react';
import { cssMap, jsx } from '@compiled/react';
import { useIsStreamingAdvisoryEnabled } from '@jira/ssr__streaming-enabled/src/useIsStreamingEnabled.tsx';
import { useIsStagingOrDevOrLocal } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import { token } from '@atlaskit/tokens';

// I promise I am being a good developer and not cheating the VC system. This component is strictly for development use
// only and cannot affect VC for customers.
const attrKey = 'vc-nvs';
const IGNORE_VC_ATTRIBUTE = {
	[`data-${attrKey}`]: true,
};

const advisoryStyles = cssMap({
	wrapper: {
		position: 'absolute',
		left: 8,
		top: 12,
		display: 'flex',
		alignItems: 'center',
		// By giving this element a height of 0 and no pointer events, we ensure that it doesn't interfere with the page.
		// To make is visible again, we then set the overflow to "visible".
		height: 0,
		overflow: 'visible',
		pointerEvents: 'none',
		zIndex: 99999999,
	},
	dot: {
		backgroundColor: '#a971ff',
		borderRadius: token('radius.full'),
		width: 8,
		height: 8,
		zIndex: 20,
	},
	label: {
		backgroundColor: '#392e5c',
		color: '#a971ff',
		height: '1.5em',
		marginLeft: token('space.negative.150'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.100'),
		borderRadius: token('radius.small'),
		zIndex: 10,
	},
});

export const StreamingAdvisory = (): React.ReactElement | null => {
	const [isAdvisoryVisible, setIsAdvisoryVisible] = useState(true);
	const isStreamingAdvisoryEnabled = useIsStreamingAdvisoryEnabled();
	const isNonProd = useIsStagingOrDevOrLocal();

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsAdvisoryVisible(false);
		}, 5000);
		return () => {
			clearTimeout(timer);
		};
	}, []);

	if (!isStreamingAdvisoryEnabled || !isNonProd) {
		return null;
	}
	return (
		<div {...IGNORE_VC_ATTRIBUTE} css={advisoryStyles.wrapper}>
			<div css={advisoryStyles.dot} />

			{isAdvisoryVisible && (
				<div css={advisoryStyles.label}>
					<samp>Server Side Streaming Enabled 🔴 go/jira-streaming</samp>
				</div>
			)}
		</div>
	);
};
